import { useQuery } from 'react-query';
import { RingAPI } from 'api/admin/ring';
import { RING } from 'helpers/constants';

export default function useRings(id) {
  return useQuery([RING, id], () => RingAPI.getById(id), { enabled: id });
}
